import React from "react";
import { useDropzone } from "react-dropzone";
import { FileImg, UploadImage } from "../Icon";
import clsx from "clsx";

interface FileDropProps extends React.HTMLAttributes<HTMLDivElement> {
  label?: string;
  addFile: (file: File[]) => void;
  files: any[];
}

function FileDrop({ label, className, addFile, files }: FileDropProps) {
  const { getRootProps, getInputProps } = useDropzone({
    maxFiles: 2,
    maxSize: 1024 * 1024 * 10,
    onDrop: (acceptedFiles: File[]) => {
      addFile(acceptedFiles);
    },
  });

  return (
    <div>
      <p>{label}</p>
      {files.length === 0 ? (
        <section
          className={clsx(
            "container border-2 p-5 border-dashed cursor-pointer",
            className
          )}
        >
          <div {...getRootProps({ className: "dropzone" })}>
            <input {...getInputProps()} />
            <div className="flex flex-col items-center">
              <FileImg />
              <p className="normal-case">
                Drop your file(s) here or{" "}
                <span className="text-info">browse</span>
              </p>
            </div>
          </div>
        </section>
      ) : (
        <div className="h-20 flex flex-wrap">
          {files?.map((file, index) => (
            <>
              <div className="h-20 w-20">
                {/* eslint-disable-next-line @next/next/no-img-element */}
                <img
                  src={URL.createObjectURL(file)}
                  alt=""
                  className="h-full w-full"
                />
              </div>
              {/* <Image
                key={index}
                src={URL.createObjectURL(file)}
                width={80}
                height={80}
                alt=""
              /> */}
            </>
          ))}
          {files.length < 4 && (
            <section
              className={clsx(
                "border-2 h-full w-20  border-dashed cursor-pointer ",
                className
              )}
            >
              <div {...getRootProps({ className: "dropzone h-full" })}>
                <input {...getInputProps()} />
                <div className="text-xs flex flex-col items-center text-center justify-center">
                  <UploadImage />
                  <p>
                    Upload <br />
                    Image
                  </p>
                </div>
              </div>
            </section>
          )}
        </div>
      )}
    </div>
  );
}

export default FileDrop;
